import { render } from "./App.vue?vue&type=template&id=39473a9c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=39473a9c&lang=css"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__